module.exports = __webpack_public_path__ + "img/hr-white-desert-bush-09.a13468bb.png";